import * as Sentry from "@sentry/browser";
import axios from "axios";
import { CurrentUser, PublicUserInvitation } from "@hilos/types/private-schema";
import { API_ROUTES, buildAPIRoute } from "../router/router";

export async function getUser() {
  try {
    const response = await axios.get<CurrentUser>("/me");

    if (response.data) {
      Sentry.setUser({
        email: response.data.email,
        ip_address: "{{auto}}",
        account: response.data.account ? response.data.account.id : undefined,
      });

      // @ts-ignore
      window.dataLayer.push({
        user_id: response.data.email,
      });

      // @ts-ignore
      if ("UserLeap" in window && window.UserLeap !== undefined) {
        // UserLeap is defined via GTM
        // Ensures UserLeap does not re-survey the same user and increases tracking accuracy
        // @ts-ignore
        window.UserLeap("setUserId", response.data.email);
        // Sets visitor's email address to enable email surveys
        // @ts-ignore
        window.UserLeap("setEmail", response.data.email);
      }
      return response.data;
    }
  } catch (err) {
    Sentry.captureException(err);
    console.log("Error when getting user", err);
  }

  return null;
}

export async function getInvitation(id) {
  const response = await axios.get<PublicUserInvitation>(
    buildAPIRoute(API_ROUTES.PUBLIC_USER_INVITATION_DETAIL, {
      ":id": id,
    })
  );

  if (response.data) {
    return response.data;
  }

  return null;
}

export async function signup(data) {
  const response = await axios.post(API_ROUTES.SIGNUP, data);
  return response;
}

export async function logoutUser() {
  const response = await axios.post(API_ROUTES.LOGOUT);
  return response;
}

export async function updateUser(data) {
  const response = await axios.patch(API_ROUTES.ME, data);

  if (response.data) {
    return response.data;
  }

  return null;
}
